import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { LocalizationService } from 'root/services';



@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: []
})
export class LocalizedComponent implements OnInit {

  public languageCode;
  private localizationSvc = inject(LocalizationService);
  private resourceStringValues = {};
  constructor() {}

  /**
    * Return the translated text by key
    * @param resourceKey Return
    */
  getString(resourceKey: string) {
    if (typeof this.resourceStringValues && this.resourceStringValues[resourceKey]) {
      return this.resourceStringValues[resourceKey];
    }
    return `${this.languageCode}:'${resourceKey}'`;
  }

  ngOnInit() {
    this.localizationSvc.currentLocale.forEach(locale => {
      this.resourceStringValues = locale.translations;
      this.languageCode = locale.code;
    });
  }


}
